import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getPayments } from 'actions/EntityActions';
import LOOKUP from 'constants/lookup';
import { paymentListCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
// Basic Components
import Button from 'screens/components/basic/Button';
import Grid from 'screens/components/basic/Grid';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
// Advanced Components
import GenericTable from 'screens/components/advanced/GenericTable';

class PaymentList extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.getPayments(this.props.branchId);
    }

    redirectToAddPayment = () => {
        this.props.navigate("/manage/payment/add");
    }

    redirectToEditPayment = (id) => {
        this.props.navigate(`/manage/payment/edit/${id}`);
    }

    render() {
        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li className="active">{LOOKUP.menu.manage.items.payment.text}</li>
                </ol>
                <h2>{LOOKUP.menu.manage.items.payment.text}</h2>
            </div>
        );

        const sideContent = null;
        // (
        //     <Panel title="Toolbox">
        //         <div className="row text-center">
        //             <Button type="AddButton"
        //                 className="toolbox-button"
        //                 label={LOOKUP.payment.controls.addNewButton}
        //                 onTouchTap={() => this.redirectToAddPayment()} />
        //         </div>
        //         {/*<hr />
        //         <h4>Search</h4>*/}
        //     </Panel>
        // );

        const listPayments = (this.props.payments || []).filter(item => item.name != "Online").map((item) => {
            return {
                // ID: (<Link className="edit-link" to={`/manage/payment/edit/${item.id}`}>{item.id}</Link>),
                Name: (<Link to={`/manage/payment/edit/${item.id}`}>{item.name}</Link>),
                Status: (item.status !== "Active" ? <p className="statusIconRed m-0">{item.status}</p> :
                    <p className="statusIconGreen m-0">{item.status}</p>),
                Icons: (
                    <div>
                        <Button
                            type="IconEditButton"
                            mini={true}
                            onTouchTap={() => this.redirectToEditPayment(item.id)} />
                    </div>
                )
            };
        });

        return (
            <Grid headerContent={paymentListCrumb}>
                <PageHeaderWithButton title={LOOKUP.menu.manage.items.payment.text}>
                    <Button
                        type="AddButton"
                        mini={true}
                        // label="ADD NEW DEVICE"
                        className="bg-light-green"
                        label={LOOKUP.payment.controls.addNewButton}
                        onTouchTap={() => this.redirectToAddPayment()} />
                </PageHeaderWithButton>
                <div className="list-table-last">
                    <div className="form-group">
                        <GenericTable
                            className="table_center tableHeaderwhiteColorFont"
                            tableBodyClassName="registers-table"
                            multiSelectable={false}
                            enableSelectAll={false}
                            displaySelectAll={false}
                            adjustForCheckbox={false}
                            displayRowCheckbox={false}
                            selectable={false}
                            stripedRows={true}
                            columns={LOOKUP.payment.tableColumns}
                            rows={listPayments} />
                    </div>
                </div>
            </Grid>
        );
    }
}

function mapStatetoProps(state) {
    return {
        payments: state.entity.paymentsList,
        branchId: state.common.branchId
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getPayments: (branchId) => dispatch(getPayments(branchId))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(PaymentList));
